import './styles.scss';
import React, { useCallback } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import { SERVICE_NAME } from '~constants/app';
import { signup } from '~redux/auth/reducers/signup';

const HomeHeroBuyers = () => {
  const dispatch = useDispatch();
  const handleSignup = useCallback(() => {
    dispatch(signup());
  }, []);

  return (
    <div className="buyer-home-main">
      <Container className="buyer-home-container">
        <h1 className="mb-5 buyer-home-title">
          Online <br className="d-none d-lg-inline" />
          wholesale
          <br />
          made for you
        </h1>

        <h5 className="mb-5">
          400以上の優良ブランドの仕入れを
          <br />
          小ロットから
          <br />
          {SERVICE_NAME}
        </h5>

        <div className="mb-4 d-block d-lg-none mb-5">
          <img src="/images/buyer/home/img-buyer.webp" alt="" loading="lazy" />
        </div>

        <div className="d-flex">
          <Button
            className="mr-4 p-2 px-md-4 py-md-2"
            onClick={handleSignup}
            outline
          >
            <span className="txt-en-ss en ls-m">for Buyer</span>
            <br />
            <span className="txt-s jp">ブランドをチェック</span>
          </Button>

          <a href="https://brands.homula.jp">
            <Button className="p-2 px-md-4 py-md-2" outline>
              <span className="txt-en-ss en ls-m">for Brands</span>
              <br />
              <span className="txt-s jp">ブランドの方はこちら</span>
            </Button>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default HomeHeroBuyers;
